import { useState } from '@wordpress/element';
import ReiniciarTicket from './ReiniciarTicket';
import ValorCompra from './ValorCompra';
import Bonos from './Bonos';
import ValidarBonos from './ValidarBonos';
import InsertarTicket from './InsertarTicket';

export default function GestionApp( {
	maxBonosComercio,
	remainingBonos,
	progresoConvocatoria,
	status,
} ) {
	const [ possibleBonos, setPossibleBonos ] = useState( null );
	const [ ticketValue, setTicketValue ] = useState( 0 );
	const [ readedBonos, setReadedBonos ] = useState( [] );
	const [ isValidated, setIsValidated ] = useState( false );
	const [ insertedTicket, setInsertedTicket ] = useState( null );
	const [ insertTicketImg, setInsertTicketImg ] = useState( false );

	return (
		<>
			<ReiniciarTicket
				text={ 'Reiniciar ticket' }
				status={ status }
				remainingBonos={ remainingBonos }
				maxBonosComercio={ maxBonosComercio }
				progresoConvocatoria={ progresoConvocatoria }
			/>
			<ValorCompra
				possibleBono={ [ possibleBonos, setPossibleBonos ] }
				setTicketValue={ setTicketValue }
				remainingBonos={ remainingBonos }
			/>
			{ possibleBonos && (
				<Bonos
					bonos={ [ possibleBonos, setPossibleBonos ] }
					ticketValue={ ticketValue }
					readedBonosState={ [ readedBonos, setReadedBonos ] }
				/>
			) }
			{ readedBonos.length > 0 && (
				<ValidarBonos
					readedBonos={ readedBonos }
					isValidatedState={ [ isValidated, setIsValidated ] }
					ticketValue={ ticketValue }
					setInsertedTicket={ setInsertedTicket }
					insertTicketImg={ insertTicketImg }
					setInsertTicketImg={ setInsertTicketImg }
				/>
			) }
			{ isValidated && (
				<>
					<div className="sci-bcl-valid-overlay"></div>
				</>
			) }
			{ isValidated && insertTicketImg && (
				<>
					<InsertarTicket insertedTicket={ insertedTicket } />
				</>
			) }
		</>
	);
}
